import React, { FC, PropsWithChildren } from 'react';

import { Loader } from '@eika/loader';

import { skadetypeFrom, skadetypeToString } from '../../meldskade/reducer/skadetype';
import { hovedkategoriPath } from '../../router/router-urler';
import { Skademeldingstype } from '../../types/generated-types';
import { skadekategoriFrom, skadekategoriToUrlPathName } from './skadekategori';

export const urlPrecedingQuery = (url: string): string => url.split('?')[0];

export const internalSkadetypeRoute = (skadetype: Skademeldingstype): string =>
    `/skade?skadetype=${skadetypeToString(skadetype)}`;

const redirectBySkadetype = (skadetypeParam: string, baseurl: string): void => {
    const skadetype = skadetypeFrom(skadetypeParam);
    const newUrl = new URL(`#${internalSkadetypeRoute(skadetype)}`, baseurl);
    window.location.replace(newUrl.href);
};

const redirectBySkadekategori = (skadekategoriParam: string, baseurl: string): void => {
    const skadekategori = skadekategoriFrom(skadekategoriParam);
    const newUrl = new URL(`#/${skadekategoriToUrlPathName(skadekategori)}/${hovedkategoriPath}`, baseurl);
    window.location.replace(newUrl.href);
};

const redirectBySkjema = (skjema: string, baseurl: string): void => {
    const newUrl = new URL(`#/skjema/${skjema}`, baseurl.split(`/${skjema}`)[0]);
    window.location.replace(newUrl.href);
};

export const DeeplinkHandler: FC<PropsWithChildren> = ({ children }) => {
    const externalUrl = new URL(window.location.href);
    const baseurl = externalUrl.origin + externalUrl.pathname;

    if (externalUrl.search) {
        const skadetypeParam = externalUrl.searchParams.get('skadetype');
        const skadekategoriParam = externalUrl.searchParams.get('skadekategori');
        const skjemaParam = externalUrl.searchParams.get('skjema');

        if (skadetypeParam) {
            redirectBySkadetype(skadetypeParam, baseurl);
            return <Loader />;
        }
        if (skadekategoriParam) {
            redirectBySkadekategori(skadekategoriParam, baseurl);
            return <Loader />;
        }
        if (skjemaParam) {
            redirectBySkjema(skjemaParam, baseurl);
            return <Loader />;
        }
    }

    return children;
};
